import { render, staticRenderFns } from "./SailDeckList.vue?vue&type=template&id=5022c19b&scoped=true&"
import script from "./SailDeckList.vue?vue&type=script&lang=js&"
export * from "./SailDeckList.vue?vue&type=script&lang=js&"
import style0 from "./SailDeckList.vue?vue&type=style&index=0&id=5022c19b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5022c19b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5022c19b')) {
      api.createRecord('5022c19b', component.options)
    } else {
      api.reload('5022c19b', component.options)
    }
    module.hot.accept("./SailDeckList.vue?vue&type=template&id=5022c19b&scoped=true&", function () {
      api.rerender('5022c19b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/sail/SailDeckList.vue"
export default component.exports